import { render, staticRenderFns } from "./RegionUpload.vue?vue&type=template&id=127c2430&scoped=true"
import script from "./RegionUpload.vue?vue&type=script&lang=js"
export * from "./RegionUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c2430",
  null
  
)

export default component.exports